module.exports = __webpack_public_path__ + "static/media/background-startup.dea1240b.jpg";